export default __webpack_public_path__ + "static/media/next_arrow.84981e96.svg";